/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from "react";
import { AppBanner } from "./components/AppBanner";
import { ApprovalFlowWall } from "./components/ApprovalFlowWall";
import { CorporatePlanWall } from "./components/CorporatePlanWall";
// import { CorporateWall } from "./components/CorporateWall";
import { NewsWall } from "./components/NewsWall";
import { PortalPageContainer } from "./components/PortalPageContainer";
import "./less/antMotionStyle.less";

export default class HomePage extends React.Component {
  childrenRender = (props: {
    toggleConsultModalVisible: () => void;
    togglePartnerModalVisible: () => void;
  }) => {
    return (
      <>
        <AppBanner onClickPartner={props.togglePartnerModalVisible} />
        {/* <CorporateWall /> */}
        <CorporatePlanWall />
        <ApprovalFlowWall />
        <NewsWall />
      </>
    );
  };

  render() {
    return (
      <PortalPageContainer
        childrenRender={this.childrenRender}
      ></PortalPageContainer>
    );
  }
}
